import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const IsInBottomSheetContext = /*#__PURE__*/ React.createContext(false);
export const useIsInBottomSheet = ()=>useContext(IsInBottomSheetContext);
export const IsInBottomSheetProvider = (param)=>{
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(IsInBottomSheetContext.Provider, {
        value: value,
        children: children
    });
};
